import api from "./axios";

export const getBOMs =
() =>
api.get("/bom");

export const getBOMById =
(id) =>
api.get(`/bom/${id}`);

export const createBOM =
(data) =>
api.post("/bom", data);

export const getBOMByProduct =
(productId)=>
api.get(
  `/bom/product/${productId}`
);